<p-dialog
  position="topleft"
  [modal]="true"
  [visible]="!!widget"
  [resizable]="true"
  [closable]="false"
  (onHide)="closeExportDialog()">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-file-export" text="Darstellung exportieren" />
  </ng-template>
  @if (widget) {
    <div #exportContainer class="relative w-full h-full flex flex-column">
      <app-custom-widget [id]="widget._id" [export]="true"></app-custom-widget>
      <div class="pt-6 flex gap-4">
        <strong><i class="fas fa-info-circle"></i> {{ widgetCaption }}</strong>
        <i class="text-color-secondary"
          ><i class="fas fa-copyright"></i> {{ globalsStore.sourceString() }}</i
        >
      </div>
    </div>
  }
  <ng-template pTemplate="footer">
    <div class="flex gap-3 align-items-center pt-3">
      <p-button
        [rounded]="true"
        label="abbrechen"
        [text]="true"
        severity="secondary"
        icon="fas fa-xmark"
        (onClick)="closeExportDialog()" />
      <p-button
        [rounded]="true"
        class="ml-auto"
        label="konfigurieren"
        [outlined]="true"
        icon="fas fa-cog"
        severity="primary"
        (onClick)="showConfig()" />
      <p-button
        [rounded]="true"
        icon="fas fa-file-export"
        label="exportieren"
        (onClick)="exportWidget()" />
    </div>
  </ng-template>
</p-dialog>
